// dependencies
import { fromJS } from "immutable";

export default fromJS({
	currentPage: 1,
	reviewReports: [],
	author: {},
	company: {},
	reportID: "",
});
